import React from "../../../__snowpack__/pkg/react.js";
const TableRowActionsContext = React.createContext({keepMoreButtonPopoverOpen: false, setKeepMoreButtonPopoverOpen: () => {
}});
export default TableRowActionsContext;
